import { Api } from '@api';

import { actionCreatorAsync } from '../creator';

import {
	IActionTargetsFetchItemPayload,
	IActionTargetsFetchItemPayloadDone,
	IActionTargetsFetchItemPayloadError,
} from './types';

export const targetsFetchItem = actionCreatorAsync<
	IActionTargetsFetchItemPayload,
	IActionTargetsFetchItemPayloadDone,
	IActionTargetsFetchItemPayloadError
>(
	'targetsFetchItem',
	async (params) => {
		const { data } = await Api.targets.fetchItem({ params });

		return data;
	},
);
